import { useEffect, useState } from "react";

export default function useLocationReviews(googlePlacesId) {
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState(null);

  const loadReviews = async (googlePlacesId) => {
    setLoading(true);
    const params = new URLSearchParams();

    params.append("location", googlePlacesId);

    const url = `/api/location-reviews?${params.toString()}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      setReviews({
        rating: data.result.rating,
        user_ratings_total: data.result.user_ratings_total,
        reviews: data.result.reviews
          .sort((a, b) => (a.time < b.time ? 1 : -1)) // Sort by time.
          .filter((review) => review.rating === 5) // Only show 5 star reviews.
          .splice(0, 3), // Limit to only 3 reviews.
        url: data.result.url
      });
    } catch (e) {
      setError(e.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadReviews(googlePlacesId);
  }, [googlePlacesId]);

  return { loading, reviews, error };
}
